import React from "react";
import Permission from "../../Common/Permission";
import Table from "../../Common/Table";
import TableFields from "../../../constants/DriverTags/TableFields.json";
import { getPath } from "../../../utils";
import MenuActionsMappings from "../../../constants/Menu/MenuActionsMappings";
import MenuNames from "../../../constants/Menu/MenuNames.json";
import { Pill } from "../../../constants/assets/containers";

const DriverTagsList = (props) => {
  const { handleClick, driverTagsList } = props;
  const allActions = MenuActionsMappings[MenuNames.DRIVER_TAG];

  const getFieldValue = (item, key) => {
    switch (key) {
      case "enabled":
        return <Pill isFalse={!item[key]}>{item[key] ? "Yes" : "No"}</Pill>;
      case "actions":
        return (
          <Permission
            optionalPerms={[allActions.DETAIL, allActions.UPDATE]}
            notAllowedText="No Actions Allowed"
          >
            <span
              onClick={() => handleClick("Edit", item.id)}
              className={"edit-options cursor-pointer"}
            >
              View/Edit
            </span>
          </Permission>
        );
      default:
        return getPath(item, key, "NA");
    }
  };

  return (
    <Permission requiredPerms={[allActions.LIST]}>
      <Table
        list={driverTagsList}
        getFieldValue={getFieldValue}
        fields={TableFields}
      />
    </Permission>
  );
};

export default DriverTagsList;
